import React, { useState, useEffect, useContext, Fragment } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import Admin from './Admin';
import Loading from '../../components/OtherElements/Loading';
import { store } from '../../store';
import axios from '../../api/axios';
import Logout from '../Public/Logout';
import { useQuery } from 'react-query';

const ProtectedRoutes = () => {
  const [loading, setLoading] = useState(true);
  const { state, dispatch, showMessage, showError } = useContext(store);
  const { profile, workspace } = state.Auth;
  const location = useLocation();

  const loadUserInformations = async () => {
    localStorage.setItem('referUrl', location.pathname);
    try {
      const { data } = await axios.get(`/api/v1/admin/user/me`);
      if (data.ok) {
        localStorage.removeItem('referUrl');
        let workspace;
        data?.user.role[0] === 'admin' && (workspace = 'admin');
        dispatch({
          type: 'AUTH',
          action: 'SET_PROFILE',
          payload: { profile: data.user, workspace },
        });
        setLoading(false);
        return data;
      }
    } catch (error) {
      showError(error);
    }
  };

  const { data } = useQuery('loadMe', loadUserInformations, {
    cacheTime: 24 * 60 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return (
    <Fragment>
      {loading ? (
        <Loading text="کمی صبر کنید ..." />
      ) : (
        <Switch>
          <Route
            path="/protected/admin"
            render={() => (workspace === 'admin' ? <Admin /> : <Logout />)}
          />

          <Route
            exact
            path="/protected"
            render={() => (
              <Redirect
                to={
                  workspace === 'admin' ? `/protected/${workspace}` : `/logout`
                }
              />
            )}
          />
        </Switch>
      )}
    </Fragment>
  );
};

export default ProtectedRoutes;
